<section class="pt-16 px-container">
    <h1 class="text-3xl md:text-5xl lg:text-6xl">Abbecedario</h1>    
</section>

<section class="pt-16 px-container" [ngClass]="{'pb-16': definizioni_raggruppate.length !== 1}">
    <h4 class="lg:text-2xl text-xl font-medium mb-4">Cerca la definizione:</h4>
    <div class="flex lg:flex-row flex-col w-full">
        <p-autoComplete (onSelect)="onSelectDefinizione($event)" (onClear)="getData()" (completeMethod)="onFilterDefinizioni($event)" [suggestions]="definizioni_filtrate" field="titolo" class="autocomplete autocomplete-definizioni lg:w-4/5 w-full" placeholder="Info teatro" [emptyMessage]="'Nessuna definizione trovata!'" />                    
        <button class="clear lg:w-1/5 w-full lg:mt-0 mt-4 p-5 border border-[#ccc] button font-medium" type="button" [disabled]="definizioni_raggruppate.length !== 1" (click)="getData()">Pulisci la ricerca</button>
    </div>
</section>

<section *ngIf="definizioni_raggruppate.length !== 1" class="px-container">
    <nav class="nav w-full text-center flex flex-wrap flex-row justify-center">
        <a routerLink="/abbecedario" fragment="A">A</a>
        <a routerLink="/abbecedario" fragment="B">B</a>
        <a routerLink="/abbecedario" fragment="C">C</a>
        <a routerLink="/abbecedario" fragment="D">D</a>
        <a routerLink="/abbecedario" fragment="E">E</a>
        <a routerLink="/abbecedario" fragment="F">F</a>
        <a routerLink="/abbecedario" fragment="G">G</a>
        <a routerLink="/abbecedario" fragment="H">H</a>
        <a routerLink="/abbecedario" fragment="I">I</a>
        <a routerLink="/abbecedario" fragment="J">J</a>
        <a routerLink="/abbecedario" fragment="K">K</a>
        <a routerLink="/abbecedario" fragment="L">L</a>
        <a routerLink="/abbecedario" fragment="M">M</a>
        <a routerLink="/abbecedario" fragment="N">N</a>
        <a routerLink="/abbecedario" fragment="O">O</a>
        <a routerLink="/abbecedario" fragment="P">P</a>
        <a routerLink="/abbecedario" fragment="Q">Q</a>
        <a routerLink="/abbecedario" fragment="R">R</a>
        <a routerLink="/abbecedario" fragment="S">S</a>
        <a routerLink="/abbecedario" fragment="T">T</a>
        <a routerLink="/abbecedario" fragment="U">U</a>
        <a routerLink="/abbecedario" fragment="V">V</a>
        <a routerLink="/abbecedario" fragment="W">W</a>
        <a routerLink="/abbecedario" fragment="X">X</a>
        <a routerLink="/abbecedario" fragment="Y">Y</a>
        <a routerLink="/abbecedario" fragment="Z">Z</a>
    </nav>        
</section>

<section class="pb-16 mb-8 px-container">
    <div class="alfabeto flex flex-col gap-8" *ngFor="let alfabeto of definizioni_raggruppate">
        <h1 class="lg:text-6xl text-4xl font-bold uppercase mt-8 py-8" [id]="alfabeto.alfabeto">{{alfabeto.alfabeto}}</h1>
        <div class="definizione lg:px-8 border-[#ccccc] border-dashed relative" *ngFor="let definizione of alfabeto.elementi" [id]="definizione.id_definizione">
            <div class="top-1/2 left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-4/5 -translate-y-1/2"></div>
            <h1 class="lg:text-4xl text-2xl font-medium mb-8">{{definizione.titolo}}</h1>
            <div class="text-justify" [innerHTML]="definizione.definizione"></div>
        </div>
    </div>
</section>

<p-scrollTop />
